import React from "react"
import { Tabs } from "components";
import { useGetAllowedValues } from "hooks";
import { SCORECARD_ALLOWED_PERIODS } from "./consts";
import { ScorecardLayout } from "./components/layout/ScorecardLayout";

const ScorecardPage = () => {
    const { data: sitesData, isLoading } = useGetAllowedValues();
    const periods = [...SCORECARD_ALLOWED_PERIODS];
    const tabConfig = periods.map((val) => ({
        label: val,
        content: <ScorecardLayout selectedPeriod={val} sitesData={sitesData} isLoading={isLoading} />
    }))

    return (
        <Tabs
            tabs={tabConfig}
            variant='custom'
            displayInfoLabel
            infoLabelTitle="Data Entry Period"
            infoLabelMessage="For each KPI, data can only be entered in one time period. Other periods will become read-only once data is entered."
            tabsSx={{
                "& .MuiTabs-scroller": {
                    marginLeft: "24px",
                },
            }} />
    )
}

export default ScorecardPage;